export const getCraftLetter = (name?: string | null, code?: string | null) =>
	code || name?.charAt(0) || "";
